import { DashboardHeader } from "@complex/DashboardHeader";
import { Stack } from "@mui/material";
import { ResponsiveFilters } from "@styleguide";
import type { Dispatch } from "react";
import type { FiltersActions, TCandidateFilters } from "../logics/types";
import { CandidatePlaceFilter } from "./place";
import { useCandidatePlaceFilter } from "./place/logics";
import { CandidateStatusFilter } from "./status";
import { useCandidateStatusFilter } from "./status/logics";

interface ISocialOffersDetailsFiltersProps {
  filters: TCandidateFilters;
  dispatch: Dispatch<FiltersActions>;
}

export const SocialOffersDetailsFilters = ({ filters, dispatch }: ISocialOffersDetailsFiltersProps) => {
  const { innerStatus, setInnerStatus, ...statusFilterProps } = useCandidateStatusFilter(filters, dispatch);
  const { innerPlaces, setInnerPlaces, ...placeFilterProps } = useCandidatePlaceFilter(filters, dispatch);

  return (
    <Stack sx={{ backgroundColor: "surface.main" }}>
      <DashboardHeader
        onReset={() => dispatch({ type: "reset" })}
        search={filters.search}
        onSearch={(v) => dispatch({ type: "search", payload: v })}
        searchPlaceholder="Rechercher un nom, un numéro..."
        display="compact"
      >
        <ResponsiveFilters
          key="filters"
          filters={[
            {
              label: "Lieu de résidence",
              content: (
                <CandidatePlaceFilter innerPlaces={innerPlaces} setInnerPlaces={setInnerPlaces} {...placeFilterProps} />
              ),
              ...placeFilterProps,
            },
            {
              label: "Statut",
              content: (
                <CandidateStatusFilter
                  innerStatus={innerStatus}
                  setInnerStatus={setInnerStatus}
                  {...statusFilterProps}
                />
              ),
              ...statusFilterProps,
            },
          ]}
          onReset={() => dispatch({ type: "reset" })}
        />
      </DashboardHeader>
    </Stack>
  );
};
